import React from "react";

import tour_screen_01 from "images/custom/tour/tour_graphic_01.png";
import tour_screen_02 from "images/custom/tour/tour_graphic_02.png";
import tour_screen_03 from "images/custom/tour/tour_graphic_03.png";
import TourSlider from "components/shared/Tour/TourSlider";

import Slider from "react-slick";

import localize from "lang/localize";

class AhmaTourSlider extends TourSlider {
  /**
   * Override for core render()
   */
  render() {
    const SETTINGS = this.getSliderSettings();
    /* No API support for tour screens yet, fall back to legacy tour screens implementation */
    return this.renderLegacyTourScreens(this, SETTINGS);
  }

  /**
   * Support for older tour screens
   *
   * Customization note for apps:
   * This method should be overwritten in a custom component to support older apps
   */
  renderLegacyTourScreens(slider, settings) {
    // --- Code example to render legacy tour screens ---
    // Define the number of slides here
    slider.slidesLength = 3;

    // Copy all code from <Slider> </Slider> from legacy implementations into here:
    // Ensure there are no traces of this.props.projectId because tour screens are now app-centric
    return (
      <Slider {...settings}>
        <div>
          <div className="pure-g bottommargin-20">
            <div className="pure-u-1-4 pure-u-md-1-3" />
            <div className="pure-u-1-2 pure-u-md-1-3">
              <img src={tour_screen_01} alt="" className="imgresponsive" />
            </div>
            <div className="pure-u-1-4 pure-u-md-1-3" />
          </div>
          <div className="pure-g">
            <div className="pure-u-1-6" />
            <div className="pure-u-2-3">
              <p className="textcenter">
                {localize("tour_slider_text_1", this.props.language)}
                <a
                  href="https://app.gametize.com/topic/47806"
                  target="_blank"
                  rel="noreferrer"
                >
                  {localize("here_link", this.props.language)}
                </a>
                !
              </p>
            </div>
            <div className="pure-u-1-6" />
          </div>
        </div>
        <div>
          <div className="pure-g bottommargin-20">
            <div className="pure-u-1-4 pure-u-md-1-3" />
            <div className="pure-u-1-2 pure-u-md-1-3">
              <img src={tour_screen_02} alt="" className="imgresponsive" />
            </div>
            <div className="pure-u-1-4 pure-u-md-1-3" />
          </div>
          <div className="pure-g">
            <div className="pure-u-1-6" />
            <div className="pure-u-2-3">
              <p className="textcenter">
                {localize("tour_slider_text_2", this.props.language)}
                <a
                  href="https://app.gametize.com/topic/47806"
                  target="_blank"
                  rel="noreferrer"
                >
                  {localize("here_link", this.props.language)}
                </a>
                !
              </p>
            </div>
            <div className="pure-u-1-6" />
          </div>
        </div>
        <div>
          <div className="pure-g bottommargin-20">
            <div className="pure-u-1-4 pure-u-md-1-3" />
            <div className="pure-u-1-2 pure-u-md-1-3">
              <img src={tour_screen_03} alt="" className="imgresponsive" />
            </div>
            <div className="pure-u-1-4 pure-u-md-1-3" />
          </div>
          <div className="pure-g">
            <div className="pure-u-1-6" />
            <div className="pure-u-2-3">
              <p className="textcenter">
                {localize("tour_slider_text_3", this.props.language)}
              </p>
            </div>
            <div className="pure-u-1-6" />
          </div>
        </div>
      </Slider>
    );

    // If no legacy tour screens defined, redirect to main screen
    //slider.props.handleCloseClick();
    //return null;
  }
}

export default AhmaTourSlider;
